// extracted by mini-css-extract-plugin
export default {"container":"ShowInfo_container__c76S8","info":"ShowInfo_info__Gejal","subTitle":"ShowInfo_subTitle__Du0uo","title":"ShowInfo_title__qC7tt"};